import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';


const getImageSrc = (url) => {
  if (!url) return '/placeholder.jpg';
 return url;
};

export default function ProductCard({ product }) {
  const { addToCart } = useCart();

  const handleAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);

    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
 content_name: product.name,
      content_ids: [product.slug],
      content_type: 'product',
      value: product.price,
      currency: 'ILS'
      });
    }
  };

  // stock & discount helpers
  const inStock = product.stock > 0;
  const discount = product.old_price
    ? Math.round((1 - product.price / product.old_price) * 100)
    : null;

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group block bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-red-600/50 transition-all duration-300 hover:shadow-lg hover:shadow-red-600/5"
    >
      {/* Image */}
      <div className="relative aspect-square bg-neutral-800 overflow-hidden">
        <img
          src={getImageSrc(product.image_url)}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />

        {/* Discount badge */}
        {discount && discount > 0 && (
          <span className="absolute top-3 right-3 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded-lg">
            -{discount}%
          </span>
        )}

        {/* Out of stock badge */}
        {!inStock && (
          <span className="absolute top-3 left-3 bg-black/70 backdrop-blur-sm text-white text-xs font-bold px-2 py-1 rounded-lg">
            نفذت الكمية
          </span>
        )}

        {/* Add to cart overlay */}
        <button
          onClick={handleAdd}
          disabled={!inStock}
          className={`absolute bottom-0 left-0 right-0 py-3 text-sm font-bold text-center transition-all duration-300 ${
            inStock
              ? 'bg-red-600 text-white translate-y-full group-hover:translate-y-0'
              : 'bg-neutral-700 text-neutral-400 cursor-not-allowed translate-y-0'
          }`}
        >
          {inStock ? 'أضف للسلة' : 'غير متوفر'}
        </button>
      </div>

      {/* Info */}
      <div className="p-4 text-right">
        <span className="text-xs text-neutral-500 uppercase tracking-wide">
          {product.category_ar || product.category}
        </span>
        <h3 className="text-white font-bold text-sm mt-1 leading-tight line-clamp-2">
          {product.name}
        </h3>

        <div className="flex items-baseline gap-2 mt-2">
          <span className="text-red-500 font-black text-lg">
            {product.price} شيكل
          </span>
          {product.old_price && (
            <span className="text-neutral-500 line-through text-sm">
              {product.old_price} شيكل
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}